import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import { useNavigate } from '@reach/router';
import HtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';

import { sortByOrder } from '../../../../provider/utility';
import { changedMapFilter, selectedCity } from '../../../../store/actions';
import { serviceTypes } from '../../../../store/initData/services';
import { env } from '../../../../utils/env';
import AccordionWithSearch from '../../../AccordionWithSearch';
import SelectOption from '../../../SelectOption/SelectOption';
import SliderFormField from '../../../SliderFormField/SliderFormField';
import styles from './FilterMenu.module.scss';

const useStyles = makeStyles(() => ({
  closeButton: {
    border: '1px solid var(--color-main-orange)',
    padding: 0,
    color: 'var(--color-main-orange)',
    marginLeft: '20px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export function FilterMenu({ onClose }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cityFormLabel = useSelector((store) => store.data.cityFormLabel);

  const levelHeader = useSelector((store) => store.data.mapPage.levelHeader);

  const currentService = useSelector((store) => store.state.service);
  const isWorkshopService = currentService.value === serviceTypes.workshop;
  const cityPageTexts = useSelector((store) => store.data.cityPage);
  const availableFranchises = useSelector((store) => store.data.franchises);
  const availableCities = availableFranchises?.map((fr) => ({
    text: fr.name,
    // Remap Gdynia to Gdańsk
    value: (fr.id === 19) ? 3 : fr.id,
    franchise: fr,
  }));
  const currentCity = useSelector((store) => store.state.city);
  const mapFilters = useSelector((store) => store.state.map.filters);
  const currentAge = useSelector((store) => store.state.age);
  const ageLinkValue = currentAge?.value || 0;

  const availableRobots = convertWorkshopLevelsToFilterButtons(
    currentCity.franchise.levels,
  );

  const currentRobot = useSelector((store) => store.state.robot);

  const handleSelectCity = (city) => {
    dispatch(selectedCity(city));
    const workshopRoute = isWorkshopService
      ? `/${ageLinkValue}${currentRobot ? `/${currentRobot.value}` : ''}`
      : '';

    const serviceRoute = `${env.PUBLIC_URL}/${currentService.value}/${city.value}`;
    navigate(serviceRoute + workshopRoute);
  };

  const entries = mapFilters.filter((filter) =>
    currentService.mapFilters.includes(filter.slug),
  );

  const iconStyles = useStyles();
  const filterText = useSelector((store) => store.data.filterMenuText);

  const onChange = (filterId) => dispatch(changedMapFilter(filterId));

  const Entry = ({ children, label, style = {}, yesno = false }) => (
    <div style={style} className={yesno ? styles.entry_yesno : styles.entry}>
      <div className={styles.label}>{HtmlParser(label)}</div>
      {children}
    </div>
  );

  return (
    <div className={styles.container}>
      <div className={styles.heading}>
        <div className={styles.heading__text}>{filterText}</div>
        <IconButton
          aria-label="close"
          size="small"
          className={iconStyles.closeButton}
          onClick={onClose}
        >
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
      </div>
      <div className={styles.entryContainer}>
        {entries.map((data, index) => (
          <Entry key={index} label={data.text} yesno>
            <SliderFormField
              checked={data.checked}
              onChange={() => onChange(data.slug)}
            />
          </Entry>
        ))}

        {/* new filters */}
        <Entry key={101} label={cityFormLabel} style={{ zIndex: 3 }}>
          <AccordionWithSearch
            small
            data={availableCities}
            selected={currentCity}
            onClick={handleSelectCity}
            placeholder={cityPageTexts.placeholder}
          />
        </Entry>

        {isWorkshopService && (
          <Entry key={103} label={levelHeader}>
            <SelectOption
              items={availableRobots}
              selected={currentRobot}
              onClick={(item) =>
                navigate(
                  `${env.PUBLIC_URL}/${currentService.value}/${currentCity.value}/${ageLinkValue}/${item.value}`,
                )
              }
              displayPrimaryButton={true}
            />
          </Entry>
        )}
      </div>
    </div>
  );
}

const convertWorkshopLevelsToFilterButtons = (wsLevels) =>
  sortByOrder(
    wsLevels.map((lvl) => ({
      ...lvl,
      type: 'robot',
      value: lvl.id,
      title: lvl.name,

      text: lvl.name,
    })),
  );
